import { ModuleFE_EMInterface, ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { Module, sortArray } from '@nu-art/ts-common';
import { ModuleFE_AdvisorAnalytics } from '../../_analytics/consts.js';
class ModuleFE_AdvisorEvents_Class extends Module {
    initialBgFinished = false;
    __onAdvisorReset = () => {
        this.initialBgFinished = false;
    };
    __onBackgroundTasksChanged() {
        if (ModuleFE_EMInterface.hasBackgroundTasks() || this.initialBgFinished)
            return;
        this.initialBgFinished = true;
        this.reportChiefComplaints(ModuleFE_RuntimeFinding.getChiefComplaints());
    }
    __onChiefComplaintsChanged = (_prev, current) => {
        if (!this.initialBgFinished)
            return;
        this.reportChiefComplaints(current);
    };
    reportChiefComplaints = (reports) => {
        const sorted = sortArray([...reports], report => report.variableId);
        ModuleFE_AdvisorAnalytics.trigger.general.app_reportCC({
            chiefComplaintIds: sorted.map(report => report.variableId),
            chiefComplaintNames: sorted.map(report => report.label),
        });
    };
}
export const ModuleFE_AdvisorEvents = new ModuleFE_AdvisorEvents_Class();
//# sourceMappingURL=ModuleFE_AdvisorEvents.js.map